import { useEffect, useState } from "react";

export default function useCountUp(targetValues, start = false, duration = 2000, intervalTime = 10) {
  const [counts, setCounts] = useState(targetValues.map(() => 0));

  useEffect(() => {
    if (!start) return;

    const steps = duration / intervalTime;
    const increments = targetValues.map((value) => value / steps);

    let currentStep = 0;
    const interval = setInterval(() => {
      currentStep++;
      setCounts((prevCounts) =>
        prevCounts.map((count, i) => {
          const nextValue = count + increments[i];
          return nextValue >= targetValues[i] ? targetValues[i] : nextValue;
        })
      );
      if (currentStep >= steps) clearInterval(interval);
    }, intervalTime);

    return () => clearInterval(interval);
  }, [start, targetValues, duration, intervalTime]);

  return counts;
}